export default __webpack_public_path__ + "static/media/clickdown.4efde20a.wav";